<template>
  <div class="mb-1">
    <label
      :class="
        bold
          ? 'text-base text-grey700 font-semibold '
          : 'text-sm text-grey700 font-medium'
      "
      :for="forVal"
    >
      {{ labelText }}
    </label>
  </div>
</template>

<script>
export default {
  props: ["forVal", "labelText", "bold" , 'error'],
  mounted() {
    // console.log(this.bold);
  },
};
</script>